import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick updates a system alias map in the shared memory for a specified user.
 */
export default class SetInSystemAliasMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userId
     * @param {string} systemAlias
     * @param {function()} forwardEvent
     */
    update($, [userId, systemAlias], [forwardEvent]) {
        Service.publish('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.USER_SYSTEM_ALIAS_SET, userId, systemAlias})
            .then(forwardEvent);
    }
}

registerBrick('0197c5eddec6e9a61644', SetInSystemAliasMap);
